import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import AuthRequire from './context/AuthRequire';
import Unauthenticated from './home/Unauthenticated';
import Authenticated from './home/Authenticated';
import AboutUs from './about-us/AboutUs';
import Blog from './blog/Blog';
import Account from './account/Account';

import WebScrapping from './webscrapp/Webscrapping';

import Login from './gral-components/Login';
import Register from './gral-components/Register';
import SuccessRegister from './gral-components/SuccessRegister';
import PasswordReset from './gral-components/PasswordReset';



class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      join: false,
      success: false,
      passwordReset: false
    };
  }

  loginOpenHandle = () => {
    this.setState({ login: true })
  };
  loginCloseHandle = () => { this.setState({ login: false }) };
  joinOpenHandle = () => {
    this.setState({ join: true })
  };
  joinCloseHandle = () => { this.setState({ join: false }) };
  successOpenHandle = () => { this.setState({ success: true }) };
  successCloseHandle = () => { this.setState({ success: false }) };
  passwordResetOpenHandle = () => { this.setState({ passwordReset: true }) };
  passwordResetCloseHandle = () => { this.setState({ passwordReset: false }) };
  loginToJoin = () => {
    this.setState({
      login: false,
      join: true
    })
  };
  joinToLogin = () => {
    this.setState({
      join: false,
      login: true
    })
  };
  loginToPasswordReset = () => {
    this.setState({
      login: false,
      passwordReset: true
    })
  };
  passwordResetToLogin = () => {
    this.setState({
      passwordReset: false,
      login: true
    })
  };
  successTologin = () => {
    this.setState({
      success: false,
      login: true
    })
  }; 
  render() {
    return (
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path='/'
              element={
                <Unauthenticated
                  loginOpenHandle={this.loginOpenHandle}
                  joinOpenHandle={this.joinOpenHandle}
                />
              }
            />
            <Route
              path='/about-us'
              element={
                <AboutUs
                  loginOpenHandle={this.loginOpenHandle}
                  joinOpenHandle={this.joinOpenHandle}
                />
              }
            />
            <Route
              path='/blog'
              element={
                <Blog
                  loginOpenHandle={this.loginOpenHandle}
                  joinOpenHandle={this.joinOpenHandle}
                />
              }
            />
            <Route path='/webscrapp' element={<WebScrapping />} />
            <Route
              path='/authenticated'
              element={
                <AuthRequire>
                  <Authenticated />
                </AuthRequire>
              }>
            </Route>
            <Route
              path='/account'
              element={
                <AuthRequire>
                  <Account />
                </AuthRequire>
              }>
            </Route>
          </Routes>
          <Login
            joinState={this.state.join}
            loginState={this.state.login}
            successState={this.state.success}
            passwordResetState={this.state.passwordReset}
            loginClose={this.loginCloseHandle}
            toJoin={this.loginToJoin}
            toPasswordReset={this.loginToPasswordReset}
          />
          <PasswordReset
            joinState={this.state.join}
            loginState={this.state.login}
            successState={this.state.success}
            passwordResetState={this.state.passwordReset}
            passwordResetClose={this.passwordResetCloseHandle}
            toLogin={this.passwordResetToLogin}
          />
          <Register
            joinState={this.state.join}
            loginState={this.state.login}
            successState={this.state.success}
            passwordResetState={this.state.passwordReset}
            joinClose={this.joinCloseHandle}
            toLogin={this.joinToLogin}
            successOpen={this.successOpenHandle}
          /> 
          <SuccessRegister
            joinState={this.state.join}
            loginState={this.state.login}
            successState={this.state.success}
            passwordResetState={this.state.passwordReset}
            successClose={this.successCloseHandle}
            toLogin={this.successTologin}
          />
        </AuthProvider>
      </BrowserRouter>
    )
  }
}

export default App;